module.exports = __webpack_public_path__ + "static/media/belch.08488751.wav";